<template>
      <div class="main-box main-content">
          <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false" >
                <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="90px">
                     <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item  label="账号：" prop="id">
                              <el-input v-model="temp.id" :disabled="true" placeholder="请输入账号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label="用户名称：" prop="userName">
                              <el-input v-model="temp.userName" placeholder="请输入用户名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label="手机号：" prop="mobile">
                              <el-input v-model="temp.mobile" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label="电子邮箱：" prop="email">
                              <el-input v-model="temp.email" placeholder="请输入电子邮箱"></el-input>
                            </el-form-item>
                        </el-col>
                       <el-col :span="12">
                         <el-form-item  label="照片：">
                           <xr-upload-single-picture :resourceId="temp.photo"  @changeMethod="updatePhoto"></xr-upload-single-picture>
                         </el-form-item>
                       </el-col>
                        <el-col :span="12">
                            <el-form-item  label="电子签名：">
                              <xr-upload-single-picture :resourceId="temp.electronicSignature"  @changeMethod="updateSignature"></xr-upload-single-picture>
                            </el-form-item>
                        </el-col>
                     </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                     <xr-button type="primary" @click.native="save('dataForm')">确定</xr-button>
                     <xr-button type="default" @click.native="dialogVisible = false">取消</xr-button>
                </div>
          </el-dialog>
      </div>
</template>

<script>
  import request from "../utils/request";

  export default {
    // userAdd
    name: 'baseInfo',
    data() {
      return {
        dialogVisible: false,
        validateIdVisible: true,
        dialogName: '基础信息',
        selectName: '',
        type: '',
        temp: {
            id: '',
            userName: '',
            mobile: '',
            email: '',
            electronicSignature: '',
            photo: '',
        },
        rules: {
          userName: [
            { message: '用户名称不能为空!', required: true, trigger: 'blur' }
          ],

        }
      }
    },
    components: {

    },
    methods: {
      //初始化页面
      init(id) {
        this.dialogVisible = true;
        this.temp.id = id;
        this.type = 'edit'
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tCoreUser_getPageInfo',
            id: id,
            type: this.type
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(this.type === 'edit'){
            if(response.data && response.data.info){
              this.temp = response.data.info;
            }
          }
        })
      },
      updateSignature(resourceId){
        this.temp.electronicSignature = resourceId;
      },
      updatePhoto(resourceId){
        this.temp.photo = resourceId;
      },
      save(){
        return request({
          method: 'post',
          url: '/web/service?method=tCoreUser_edit',
          params: this.temp
        }).then((response) =>{
          if (response.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.dialogVisible = false
                this.$emit("getUserInfo")
              }
            })
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      back(){
        this.dialogVisible = false;
      },
      //重置
      resetTemp() {
        this.temp.id = '';
        this.temp.userName = '';
        this.temp.mobile = '';
        this.temp.email = '';
        this.temp.electronicSignature = '';
        this.temp.photo = '';
        this.$nextTick(() => {      //清空校验
          this.$refs['dataForm'].clearValidate()
        })
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/HeaderPageBaseInfo.vue